import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaLock, FaClock, FaExclamationTriangle, FaArrowLeft } from 'react-icons/fa';

const CounterClosedBlock = ({ 
  cashierName = 'Cashier', 
  cashierSummary = null,
  currentBillingDate = null 
}) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Clear all authentication data
    localStorage.clear();
    sessionStorage.clear();
    
    // Navigate back to login
    navigate('/');
  };

  return (
    <div className="counter-closed-block">
      <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center px-3">
        <div className="row justify-content-center w-100">
          <div className="col-lg-10 col-md-11 col-12">
            <div className="card shadow-lg border-0" style={{
              borderRadius: '20px',
              background: 'linear-gradient(135deg, #ffebee 0%, #fce4ec 100%)',
              maxWidth: '1400px',
              margin: '0 auto',
              minWidth: '90vw'
            }}>
              <div className="card-body text-center p-5" style={{ padding: '3rem 4rem' }}>
                
                {/* Warning Icon */}
                <div className="mb-4">
                  <div className="d-flex justify-content-center align-items-center mb-3">
                    <div 
                      className="rounded-circle d-flex align-items-center justify-content-center"
                      style={{
                        width: '100px',
                        height: '100px',
                        background: 'linear-gradient(135deg, #f44336, #d32f2f)',
                        boxShadow: '0 10px 30px rgba(244, 67, 54, 0.3)'
                      }}
                    >
                      <FaLock className="text-white" style={{ fontSize: '3rem' }} />
                    </div>
                  </div>
                  <div className="alert alert-danger d-inline-block">
                    <FaExclamationTriangle className="me-2" />
                    <strong>ACCESS DENIED</strong>
                  </div>
                </div>

                {/* Header */}
                <h2 className="text-danger fw-bold mb-3">
                  Counter Already Closed
                </h2>
                
                <p className="text-muted mb-4 fs-5">
                  Your counter has already been closed for the current billing period.
                  You cannot access the system until the day is officially closed.
                </p>

                {/* Cashier Information */}
                {/* 
                <div className="card mb-4" style={{ backgroundColor: '#fff3e0', border: '1px solid #ff9800' }}>
                  <div className="card-body">
                    <h5 className="card-title text-warning mb-4 text-center">
                      <FaClock className="me-2" />
                      Counter Status Information
                    </h5>
                    
                    <div className="row g-0 bg-white rounded shadow-sm border p-3">
                      {cashierSummary ? (
                        <>
                          <div className="col-lg-2 col-md-4 col-6 text-center border-end">
                            <div className="info-section">
                              <div className="info-icon mb-2">👤</div>
                              <div className="info-label text-primary fw-bold small">USER</div>
                              <div className="info-value small fw-bold">{cashierName}</div>
                            </div>
                          </div>
                          
                          <div className="col-lg-2 col-md-4 col-6 text-center border-end">
                            <div className="info-section">
                              <div className="info-icon mb-2">📅</div>
                              <div className="info-label text-info fw-bold small">DATE</div>
                              <div className="info-value small">{currentBillingDate || new Date().toLocaleDateString()}</div>
                            </div>
                          </div>
                          
                          <div className="col-lg-2 col-md-4 col-6 text-center border-end">
                            <div className="info-section">
                              <div className="info-icon mb-2">🚫</div>
                              <div className="info-label text-danger fw-bold small">STATUS</div>
                              <div className="info-value">
                                <span className="badge bg-danger small">Closed</span>
                              </div>
                            </div>
                          </div>
                          
                          <div className="col-lg-2 col-md-4 col-6 text-center border-end">
                            <div className="info-section">
                              <div className="info-icon mb-2">💰</div>
                              <div className="info-label text-success fw-bold small">SALES</div>
                              <div className="info-value small text-success fw-bold">
                                ฿{parseFloat(cashierSummary.total_sales || 0).toLocaleString()}
                              </div>
                            </div>
                          </div>
                          
                          <div className="col-lg-2 col-md-4 col-6 text-center border-end">
                            <div className="info-section">
                              <div className="info-icon mb-2">⏰</div>
                              <div className="info-label text-warning fw-bold small">CLOSED TIME</div>
                              <div className="info-value small">{cashierSummary.close_time || 'N/A'}</div>
                            </div>
                          </div>
                          
                          <div className="col-lg-2 col-md-4 col-6 text-center">
                            <div className="info-section">
                              <div className="info-icon mb-2">🌙</div>
                              <div className="info-label text-secondary fw-bold small">SHIFT</div>
                              <div className="info-value small">{cashierSummary.shift_type || 'N/A'}</div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="col-lg-3 col-md-6 col-6 text-center border-end">
                            <div className="info-section">
                              <div className="info-icon mb-2">👤</div>
                              <div className="info-label text-primary fw-bold small">USER</div>
                              <div className="info-value small fw-bold">{cashierName}</div>
                            </div>
                          </div>
                          
                          <div className="col-lg-3 col-md-6 col-6 text-center border-end">
                            <div className="info-section">
                              <div className="info-icon mb-2">📅</div>
                              <div className="info-label text-info fw-bold small">DATE</div>
                              <div className="info-value small">{currentBillingDate || new Date().toLocaleDateString()}</div>
                            </div>
                          </div>
                          
                          <div className="col-lg-3 col-md-6 col-6 text-center border-end">
                            <div className="info-section">
                              <div className="info-icon mb-2">🚫</div>
                              <div className="info-label text-danger fw-bold small">STATUS</div>
                              <div className="info-value">
                                <span className="badge bg-danger small">Closed</span>
                              </div>
                            </div>
                          </div>
                          
                          <div className="col-lg-3 col-md-6 col-6 text-center">
                            <div className="info-section">
                              <div className="info-icon mb-2">⏰</div>
                              <div className="info-label text-secondary fw-bold small">TIME</div>
                              <div className="info-value small">N/A</div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                */}

                {/* Instructions */}
                <div className="alert alert-info text-start">
                  <h6 className="alert-heading">
                    <FaExclamationTriangle className="me-2" />
                    What happens next?
                  </h6>
                  <ul className="mb-0">
                    <li>Your counter has been successfully closed for this billing period</li>
                    <li>You cannot login again until the day is officially closed by management</li>
                    <li>Contact your manager or administrator for any urgent matters</li>
                    <li>You can login tomorrow for the next billing period</li>
                  </ul>
                </div>

                {/* Action Buttons */}
                <div className="row justify-content-center">
                  <div className="col-lg-8 col-md-10">
                    <div className="d-grid gap-3 d-md-flex justify-content-center">
                      <button 
                        className="btn btn-outline-secondary btn-lg px-5 py-3"
                        onClick={handleLogout}
                        style={{ borderRadius: '15px', minWidth: '180px' }}
                      >
                        <FaArrowLeft className="me-2" />
                        Back to Login
                      </button>
                      <button 
                        className="btn btn-outline-info btn-lg px-5 py-3"
                        onClick={() => window.location.reload()}
                        style={{ borderRadius: '15px', minWidth: '180px' }}
                      >
                        <FaClock className="me-2" />
                        Check Again
                      </button>
                    </div>
                  </div>
                </div>

                {/* Footer Note */}
                <div className="mt-4 pt-3" style={{ borderTop: '1px solid #e0e0e0' }}>
                  <small className="text-muted">
                    <strong>Note:</strong> This restriction ensures proper day-end procedures are followed.
                    <br />
                    For assistance, contact your system administrator.
                  </small>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Floating animated background elements */}
      <div className="position-fixed top-0 start-0 w-100 h-100" style={{ zIndex: -1, overflow: 'hidden' }}>
        <div 
          className="position-absolute"
          style={{
            top: '10%',
            left: '5%',
            width: '60px',
            height: '60px',
            background: 'rgba(244, 67, 54, 0.1)',
            borderRadius: '50%',
            animation: 'float 6s ease-in-out infinite'
          }}
        />
        <div 
          className="position-absolute"
          style={{
            top: '20%',
            right: '10%',
            width: '80px',
            height: '80px',
            background: 'rgba(255, 152, 0, 0.1)',
            borderRadius: '50%',
            animation: 'float 8s ease-in-out infinite 2s'
          }}
        />
        <div 
          className="position-absolute"
          style={{
            bottom: '15%',
            left: '8%',
            width: '40px',
            height: '40px',
            background: 'rgba(156, 39, 176, 0.1)',
            borderRadius: '50%',
            animation: 'float 7s ease-in-out infinite 4s'
          }}
        />
        <div 
          className="position-absolute"
          style={{
            bottom: '25%',
            right: '15%',
            width: '70px',
            height: '70px',
            background: 'rgba(33, 150, 243, 0.1)',
            borderRadius: '50%',
            animation: 'float 9s ease-in-out infinite 1s'
          }}
        />
      </div>

      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        
        .counter-closed-block {
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
          min-height: 100vh;
        }
        
        .card {
          transition: all 0.3s ease;
          backdrop-filter: blur(10px);
        }
        
        .btn {
          transition: all 0.3s ease;
        }
        
        .btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
        }
        
        .info-item {
          transition: all 0.2s ease;
          border: 1px solid rgba(0, 0, 0, 0.05);
        }
        
        .info-item:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
        
        .info-card {
          transition: all 0.2s ease;
          min-height: 90px;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        
        .info-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
        }
        
        .info-section {
          padding: 15px 8px;
          min-height: 90px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          border-radius: 8px;
        }
        
        .info-icon {
          font-size: 1.2rem;
        }
        
        .info-label {
          font-size: 0.7rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin-bottom: 5px;
          font-weight: 600;
        }
        
        .info-value {
          font-weight: 500;
          word-break: break-word;
          font-size: 0.85rem;
          line-height: 1.2;
          max-width: 100%;
          overflow-wrap: break-word;
        }
        
        @media (max-width: 992px) {
          .info-section {
            min-height: 80px;
            padding: 12px 5px;
          }
          
          .info-icon {
            font-size: 1.1rem;
          }
          
          .info-label {
            font-size: 0.65rem;
          }
          
          .info-value {
            font-size: 0.8rem;
          }
        }
        
        @media (max-width: 768px) {
          .info-section {
            border-bottom: 1px solid #dee2e6 !important;
            border-right: none !important;
            min-height: 70px;
            padding: 10px 5px;
          }
          
          .border-end {
            border-right: none !important;
          }
          
          .info-icon {
            font-size: 1rem;
            margin-bottom: 5px;
          }
          
          .info-label {
            font-size: 0.6rem;
            margin-bottom: 3px;
          }
          
          .info-value {
            font-size: 0.75rem;
          }
        }
        
        @media (max-width: 576px) {
          .info-section {
            min-height: 60px;
            padding: 8px 3px;
          }
          
          .info-icon {
            font-size: 0.9rem;
          }
          
          .info-label {
            font-size: 0.55rem;
          }
          
          .info-value {
            font-size: 0.7rem;
          }
        }
        
        .counter-closed-block .card {
          box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
        }
        
        @media (max-width: 768px) {
          .info-item {
            margin-bottom: 1rem;
          }
          
          .card {
            margin: 1rem;
          }
        }
      `}</style>
    </div>
  );
};

export default CounterClosedBlock;